import { cellStyle } from "../../../components/Table/Table.styles";
import { Office, OfficeRoom } from "../../../services/api/types/Offices";
import { roundToTwo } from "../../../services/utils/roundToTwo";

// define your filters
export const defaultDropDownFilters = {
  status: {
    id: 2,
    title: "Status",
    options: [],
    enum: true,
    enumOptions: ["Inactive", "Active"],
  },
};

// define your columns
export const getColumns = () => {
  return [
    {
      title: "Office Name",
      field: "name",
      align: "left",
      cellStyle: cellStyle,
    },
    {
      title: "Address",
      field: "address",
      cellStyle: cellStyle,
      searchable: false,
    },
    {
      title: "Status",
      field: "status",
      searchable: false,
      cellStyle: cellStyle,
      render: (office: Office) => {
        return <>{office.status === 1 ? "Active" : "Inactive"}</>;
      },
      customFilterAndSearch: (value: any, rowData: Office) => {
        if (value[value.length - 1] === "any") {
          return rowData;
        } else {
          return value.indexOf(rowData.status) > -1;
        }
      },
    },
    {
      title: "Company",
      field: "companyNames",
      render: (office: any) => {
        return <>{office.companyNames ? office.companyNames.join(",") : ""}</>;
      },
      cellStyle: cellStyle,
    },
    {
      title: "Corporate Wifi",
      field: "corporateWifi",
      align: "left",
      cellStyle: cellStyle,
    },
    {
      title: "Guest Wifi",
      field: "guestWifi",
      align: "left",
      cellStyle: cellStyle,
    },
    {
      title: "Members",
      field: "members",
      type: "numeric",
      align: "left",
      cellStyle: cellStyle,
      render: (office: any) => {
        return roundToTwo(parseFloat(office.members as unknown as string));
      },
    },
    {
      title: "Created",
      field: "createdAt",
      align: "left",
      cellStyle: cellStyle,
      render: (office: any) => {
        return (
          <>
            {office.createdAt
              ? new Date(office.createdAt.slice(0, 10)).toLocaleDateString(
                  "en-US"
                )
              : ""}
          </>
        );
      },
    },
  ];
};

// define your columns
export const getMemberColumns = () => {
  return [
    {
      title: "First Name",
      field: "firstName",
      align: "left",
      cellStyle: cellStyle,
    },
    {
      title: "Last Name",
      field: "lastName",
      cellStyle: cellStyle,
      searchable: false,
    },
  ];
};

// define your columns
export const getRoomColumns = () => {
  return [
    {
      title: "Room Name",
      field: "name",
      align: "left",
      cellStyle: cellStyle,
    },
    {
      title: "Room #",
      field: "roomNumber",
      cellStyle: cellStyle,
      searchable: false,
    },
    {
      title: "Computer #",
      field: "computerNumber",
      searchable: false,
      cellStyle: cellStyle,
    },
    {
      title: "Apple TV",
      field: "hasAppleTv",
      align: "left",
      cellStyle: cellStyle,
      render: (room: OfficeRoom) => {
        return <>{room.hasAppleTv ? "Yes" : "No"}</>;
      },
    },
    {
      title: "HDMI",
      field: "hasHdmi",
      align: "left",
      cellStyle: cellStyle,
      render: (room: OfficeRoom) => {
        return <>{room.hasHdmi ? "Yes" : "No"}</>;
      },
    },
    {
      title: "Username",
      field: "username",
      align: "left",
      cellStyle: cellStyle,
    },
    {
      title: "Password",
      field: "password",
      align: "left",
      cellStyle: cellStyle,
    },
  ];
};
